import { useTranslation } from "react-i18next";

const FilterFormLayout = ({children}) => {
    const { t } = useTranslation();
    
    return (
        <div className="z-20 py-2 sm:py-3 bg-white top-14 absolute right-0 border border-white shadow-md rounded-[10px] w-64 sm:w-72">
            <h1 className="px-2 sm:px-4 font-medium lg:text-xl capitalize">{ t('filter options')}</h1>
            <div className="mt-2 mb-2 border-t border-background-normal"></div>
            {children}
        </div>
    )
}

export default FilterFormLayout;